import React, { useEffect, useState } from 'react';
import DateTimePicker from '../../../ReusableComponents/DateTimePicker';
import Modal from '../../../ReusableComponents/Modal';
import { GLOBAL_STYLES, INDIAN_STATES, PAYMENT_STATUSES, STATUS } from '../../../appConstants';
import { Button } from '../../../Components/Helper';
import SingleFilter from '../../../features/MyRequests/SubComponents/FilterRequest/SingleFilter';
import Popup from '../../../ReusableFunctions/Popup';

const UserInvoicesFilter = ({ filter, onFilterChange, open, onClose }) => {
    const [invoicefilter, setInvoicesFilter] = useState(filter);
    const [searchQuery, setsearchQuery] = useState("");

    const handleFilterChange = (updatedFilter) => {
        setInvoicesFilter(updatedFilter);
    };

    const handleOnChangeState = (e) => {
        const value = e.target.value;
        let newStates = invoicefilter.states;
        if (e.target.checked) {
          if (newStates.length < 3) {
            newStates = [...newStates, value];
          } else {
            Popup.alert("WARNING", 'You can only select up to 3 states at time', 'ERROR')
            return;
          }
        } else {
          newStates = newStates?.filter((status) => status !== value);
        }
        newStates = Array.from(new Set(newStates));
        setInvoicesFilter((prev) => ({
          ...prev,
          states: newStates
        }));
      };

    useEffect(() => {
        const fromDate = new Date(invoicefilter.fromDate);
        let toDate = new Date(invoicefilter.toDate);
        const isSameDay = fromDate.toDateString() === toDate.toDateString()
        if (isSameDay && invoicefilter.toDate) {
            if (toDate.getTime() <= fromDate.getTime()) {
                toDate = new Date(fromDate.getTime() + 5 * 60 * 1000);
                handleFilterChange({
                    ...invoicefilter,
                    toDate
                });
            }
        }

    }, [invoicefilter.fromDate, invoicefilter.toDate])
    return (
        <Modal
            header={"Filter"}
            contentStyle={{ width: "730px", height: "auto" }}
            headingStyle={{ fontSize: "18px", fontWeight: 600 }}
            headerContainerStyle={{ padding: "20px" }}
            open={open}
            onClose={onClose}
        >
            <div style={{ padding: "20px 30px", display: "flex", flexDirection: "column", width: "100%", gap: "20px" }}>
                {/* Date Filter Section */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", gap: "10%" }}>
                    <DateTimePicker
                        title="From"
                        hideNxt={invoicefilter?.toDate?new Date(invoicefilter?.toDate):undefined}
                        selectedDateTime={invoicefilter.fromDate}
                        minTime={new Date().setHours(0, 0)}
                        maxTime={new Date().setHours(23, 59)}
                        onChange={(date) => {
                            handleFilterChange({
                                ...invoicefilter,
                                fromDate: new Date(date).toISOString()
                            });
                        }}
                    />
                    <DateTimePicker
                        title="To"
                        hidePrev={invoicefilter.fromDate}
                        selectedDateTime={invoicefilter.toDate}
                        toMinDate={new Date(invoicefilter.fromDate)}
                        minTime={new Date(invoicefilter?.fromDate).toDateString() === new Date(invoicefilter?.toDate).toDateString()
                            ? new Date(new Date(invoicefilter.fromDate).setMinutes(new Date(invoicefilter.fromDate).getMinutes() + 1))
                            : new Date().setHours(0, 0, 0, 0)}
                        onChange={(date) => {
                            let toDate = new Date(date);
                            if (!invoicefilter.toDate) {
                                toDate = new Date(toDate).setHours(23, 59, 59, 999);
                                toDate = new Date(toDate);
                            }
                            handleFilterChange({
                                ...invoicefilter,
                                toDate: toDate.toISOString()
                            });
                        }}
                        isDisable={!(invoicefilter.fromDate)}
                    />
                </div>

                {/* Active/Inactive/All Filter Section */}
                <div className='flex w-full justify-between'>
                <div style={{ marginTop: "20px" }}>
                    <h4 style={{ marginBottom: '10px', fontWeight: 600 }}>Invoice type</h4>
                    <div style={{ display: "grid", gap: "10px", gridTemplateColumns : "repeat(2, 1fr)" }}>
                        <button
                            style={{
                                padding: "10px 20px",
                                borderRadius: "5px",
                                border: "1px solid",
                                borderColor: invoicefilter.paymentMode === undefined ? "#007bff" : "#ccc",
                                backgroundColor: invoicefilter.paymentMode === undefined ? "#007bff" : "#fff",
                                color: invoicefilter.paymentMode === undefined ? "#fff" : "#000",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                                fontWeight: invoicefilter.paymentMode === undefined ? "600" : "400"
                            }}
                            onClick={() => handleFilterChange({ ...invoicefilter,statuses: [PAYMENT_STATUSES.PAID], paymentMode: undefined })}
                        >
                            Cash/UPI
                        </button>
                        <button
                            style={{
                                padding: "10px 20px",
                                borderRadius: "5px",
                                border: "1px solid",
                                borderColor: invoicefilter.paymentMode === "UPI" ? "#28a745" : "#ccc",
                                backgroundColor: invoicefilter.paymentMode === "UPI" ? "#28a745" : "#fff",
                                color: invoicefilter.paymentMode === "UPI" ? "#fff" : "#000",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                                fontWeight: invoicefilter.paymentMode === "UPI" ? "600" : "400"
                            }}
                            onClick={() => handleFilterChange({ ...invoicefilter, statuses: [PAYMENT_STATUSES.PAID], paymentMode: "UPI" })}
                        >
                            UPI
                        </button>
                        <button
                            style={{
                                padding: "10px 20px",
                                borderRadius: "5px",
                                border: "1px solid",
                                borderColor: invoicefilter.paymentMode === "Offline" ? "#000000" : "#ccc",
                                backgroundColor: invoicefilter.paymentMode === "Offline" ? "#000000" : "#fff",
                                color: invoicefilter.paymentMode === "Offline" ? "#fff" : "#000",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                                fontWeight: invoicefilter.paymentMode === "Offline" ? "600" : "400"
                            }}
                            onClick={() => handleFilterChange({ ...invoicefilter, statuses: [PAYMENT_STATUSES.PAID], paymentMode: "Offline" })}
                        >
                            Cash
                        </button>
                        <button
                            style={{
                                padding: "10px 20px",
                                borderRadius: "5px",
                                border: "1px solid",
                                borderColor: invoicefilter.paymentMode === "Cancelled" ? "#dc3545" : "#ccc",
                                backgroundColor: invoicefilter.paymentMode === "Cancelled" ? "#dc3545" : "#fff",
                                color: invoicefilter.paymentMode === "Cancelled" ? "#fff" : "#000",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                                fontWeight: invoicefilter.paymentMode === "Cancelled" ? "600" : "400"
                            }}
                            onClick={() => handleFilterChange({ ...invoicefilter, statuses: [STATUS.CANCELLED], paymentMode: "Cancelled" })}
                        >
                            Cancelled
                        </button> 
                        <button
                            style={{
                                padding: "10px 20px",
                                borderRadius: "5px",
                                border: "1px solid",
                                borderColor: invoicefilter.paymentMode === "Advanced" ? "#007bff" : "#ccc",
                                backgroundColor: invoicefilter.paymentMode === "Advanced" ? "#007bff" : "#fff",
                                color: invoicefilter.paymentMode === "Advanced" ? "#fff" : "#000",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                                fontWeight: invoicefilter.paymentMode === "Advanced" ? "600" : "400"
                            }}
                            onClick={() => handleFilterChange({
                                 ...invoicefilter,
                                 statuses: [], 
                                 paymentMode: "Advanced",
                                fromDate: new Date(new Date().setHours(0.0,0,0)).toISOString(),
                                toDate: new Date(new Date(new Date().setDate(new Date().getDate() + 30)).setHours(23, 59, 59, 999)).toISOString(),
                            })}
                        >
                            Advance
                        </button>
                    </div>
                </div>
                <div className='mt-[20px] w-[60%] max-h-[200px] '>
                <div style={{ fontSize: "16px", fontWeight: 500, display: "flex",alignItems:"center" }}>
                    <span>States</span>
                       <input
                        style={{ width: "100%",padding:"5px 8px",outline:"none", margin: "0 2px 0 4%", borderRadius: "3px", border: "1px solid #d9d9d9", color: "#3B3B3B", fontSize: "13px"}}
                        type="text"
                        placeholder="Search state here..."
                        onChange={(e) => {
                          e.preventDefault();
                          setsearchQuery(e.target.value)
                        }} />
                </div>
                   <div
                     className='
                     max-h-[90%] 
                     overflow-y-scroll 
                     overflow-x-hidden 
                     text-[14px] 
                     flex 
                     flex-col 
                     gap-[8px] 
                     text-[#3B3B3B]
                     py-2
                     transition-all
                     delay-150
                     '
                    >
                      {(searchQuery ? INDIAN_STATES.filter(s => s.toLowerCase().includes(searchQuery.toLowerCase())) : INDIAN_STATES).map((key) => {
                        return (
                          <SingleFilter
                            isChecked={invoicefilter?.states?.includes(key)}
                            onChange={handleOnChangeState}
                            value={key}
                            title={key}
                          />
                        );
                      })}
                    </div>
                </div>
            </div>
              
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "20px 30px", borderTop: '0.5px solid #BFC8D9' }}>
                <div
                    onClick={async () => {
                        setInvoicesFilter({
                            ...invoicefilter,
                             paymentMode:undefined,
                            fromDate: undefined,
                            toDate: undefined,
                            states:[],
                        })
                    }} style={{ width: "100px", color: GLOBAL_STYLES.BG_ACTIVE, fontWeight: 600, fontSize: "14px", cursor: 'pointer', display: "flex", alignItems: "center", justifyContent: "start" }}>
                    Clear all
                </div>
                <Button
                    text={"Apply"}
                    style={{ width: "130px", height: "38px", fontSize: "15px", marginRight: "10px" }}
                    onClick={() => {
                        onFilterChange(invoicefilter)
                    }}
                />
            </div>
        </Modal>
    );
};

export default UserInvoicesFilter;